import Alpine from 'alpinejs';
import EventBus from 'eventing-bus'
import {getVideoCover} from './poster'
import Constants from './constants'
import {Instance as AWS} from './aws';
import {Post, Dispatch} from './utils';
import Store from 'store2';
import $ from 'jquery';

const log = (msg, data)=> {
    console.log('[status]', msg, data)
}

export default function(){
    return {
        content_id: 'id-not-set',
        mode: 'selection',
        completed_uploads: 0,
        files_selected: [],
        files_uploading: [],
        initial_file_processing: false,
        total_transferred_hash: {},

        view_media: function(evt){
            this.dispatch(Constants.BANNER_HIDE)

            //evt.preventDefault()
            let link = $(evt.target).attr('href') || $(evt.target).closest('a').attr('href')
            this.dispatch(Constants.BANNER_HIDE)
            //window.navigation_hooked = false

            if (link) {
                window.location = link
            } else {
                window.location.reload()
            }
        },

        file_dropped: function(evt) {
            console.log('file dropped', evt)
        },

        file_changed: async function(evt) {
            this.dispatch(Constants.BANNER_SHOW);

            let handles = evt.target.files
            log('file changed', handles);
            this.initial_file_processing = true;
            let files = []
            for (let i = 0; i < handles.length; i++) {
                let f = handles[i]
                let cover;
                let image_data;
                let width;
                let height;
                let aspect;
                if (f && f.type && f.type.indexOf('video') < 0) {
                    log("Skipping video", { type: f.type, name: f.name })
                    continue;
                }

                try {
                    image_data = await getVideoCover(f)
                    console.log("received image_data", image_data);
                    cover = image_data.blob;
                    width = image_data.width;
                    height = image_data.height;
                    let a = image_data.aspect.toString();
                    if (a == "1.33") {
                        aspect = "4:3"
                    } else if (a == "1.78") {
                        aspect = "16:9"
                    } else {
                        aspect = a
                    }

                } catch (e) {
                    console.error('Failed to generate Cover Image', e);
                }

                let url_creator = window.URL || window.webkitURL;
                let cover_image_url
                if (cover) {
                    cover_image_url = url_creator.createObjectURL(cover);
                }

                let id = `${Math.round(Math.random() * 10000)}-${Math.round(Math.random() * 10000)}`;
                files.push({
                    id,
                    width, height,
                    cover,
                    cover_image_url,
                    handle: f,
                    name: f.name,
                    size: f.size,
                    type: f.type,
                    last_modified: f.lastModified,
                    aspect
                });
            }

            if (files.length > 0) {
                this.files_selected = files
            }

            this.initial_file_processing = false;
            evt.target.value = null;
        },

        remove_file: function(id) {
            let files = this.files_selected;
            log('removing file', id, 'from', files);
            return this.files_selected.filter((f)=>(f.id != id));
        },

        upload_again: function() {
            this.mode = 'selection';
            this.files_uploading = [];
            this.files_selected = [];
            this.completed_uploads = 0;
            console.log('[status] ready to upload files again');
            this.dispatch(Constants.EVENT_UPLOAD_AGAIN);
            this.dispatch(Constants.BANNER_SHOW);
        },

        finished_uploads: function(){
            console.log('[status] All Uploads Finished');
            this.mode = 'finished';
            this.dispatchFinish();
        },

        start_upload: function(evt) {
            log("Starting upload", evt)
            this.mode = "uploading"
            this.files_uploading = [];
            let i = 1000;
            for (let file of this.files_selected) {
                file.progress = 0;
                file.transferred = 0;
                file.progress_label = "Initiating Connection"
                file.progress_css = "bg-yellow-500 text-black"
                this.files_uploading.push(file);

                let ext

                if (file.type && file.type.split('/').length > 0) {
                    ext = file.type.split('/')
                    ext = ext[ext.length - 1];
                } else {
                    ext = file.type
                }

                file.path = `videos/${this.content_id}/${file.id}.${ext}`

                AWS.video_puts({
                    file: file.handle,
                    path: file.path
                }, {
                    progress: (evt)=>{
                        try {
                            file.transferred = evt.loaded;
                            file.progress_label = "Transferring..."
                            file.progress_label_css = "bg-spina-dark text-white shadow-xl"
                            file.progress = (file.transferred / file.size * 100).toFixed(2) + '%'

                            let total_transferred = 0;
                            this.files_uploading.map((f)=>{
                                let k = file.path
                                if (f.transferred) {
                                    console.log('transfer key=', k, f.transferred)
                                    this.total_transferred_hash[k] = f.transferred;
                                }
                            });

                            let total_total_transferred = 0;
                            console.log('[status] progress', this.total_transferred_hash);
                            Object.values(this.total_transferred_hash).map((i) => {
                                total_total_transferred = total_total_transferred + i })
                            this.dispatchProgress(total_total_transferred);

                            console.log("[status] aws progress", file.id, file.transferred, file.progress, evt);
                        } catch (e) {
                            console.error('progress error', e)
                        }
                    },
                    finish: async (success)=> {
                        this.completed_uploads += 1;
                        let uploading = this.files_uploading.length


                        file.uploaded = true
                        file.progress_label = "Finished"
                        file.progress_label_css = "bg-green-600 text-white"

                        if (!this.content_id || this.content_id === 'not-set') {
                            throw new Error('content_id has not been set');
                        }

                        let t = 'video'
                        if (file.type.indexOf('image') >= 0) {
                            t = 'image'
                        }

                        let s3_id = await AWS.create_attached_s3_file(
                            this.content_id,
                            {
                                id: file.id,
                                path: file.path,
                                filesize: file.size,
                                filename: file.name,
                                type: t
                            });

                        await AWS.update_cover_image(s3_id.id, file.cover);


                        if (this.completed_uploads === uploading) {
                            this.finished_uploads();
                        } else {
                            this.dispatchRemainingFileCount(uploading - this.completed_uploads);
                        }

                    }
                })
            }

            this.files_selected = [];
            this.dispatchStart({ type: "state-change", state: "uploading", files: this.files_uploading })

            setTimeout(function(){
                window.scrollTo(0,0)
            }, 200);
        },

        dispatchRemainingFileCount: function(count) {
            this.dispatch(Constants.EVENT_UPLOAD_REMAINING_COUNT, count);
        },

        dispatchFinish: function(){
            this.dispatch(Constants.EVENT_UPLOAD_FINISHED);
        },

        dispatchProgress: function(total_transferred){
            console.log('[upload-status] dispatchProgress', total_transferred);
            this.dispatch(Constants.EVENT_UPLOAD_PROGRESS, total_transferred);
        },

        dispatchStart: function(update){
            this.dispatch(Constants.EVENT_UPLOAD_START, update);
        },

        dispatch: function(key, v) {
            if (!key) { throw new Error("Invalid Key") }
            window.dispatchEvent(new CustomEvent(key, { detail: v }))
        },
    };
}

